<template>
  <div v-if="data" class="report-view">
    <InterlayerPage
      :disable-count="pageCount"
      :site="site.name"
      section="environmental"
      :baseline="site.name"
      :filters="filters"
      class="page"
      :title="$t('sections.environmental')"
      :transports="[transportMode]"
      :comment="''"
      :study-collaborators-count="data.collaboratorsCount"
      :transport-collaborators-count="data.filteredCollaboratorsCount"
    />
    <AnalysisSection v-for="(enumeration, idx) in enumerable()" :key="idx" :page-count="pageCount + idx + 1" :filters="filters">
      <template #banner>
        <Banner :data="data" :name="name" :site="site" />
      </template>
      <template #header>
        <h2>{{ $t('sections.environmental') }}</h2>
        <h5>
          {{ $t('report.environmentalImpact') }} {{ environmentalMode }}
          <span v-if="enumerable().length > 1">{{ idx + 1 }}/{{ enumerable().length }}</span>
        </h5>
      </template>
      <template #body>
        <Impact :data="data" :range="enumeration" :forcedTransport="data.transportMode.key" :yearly="yearly" :weighted="weighted" />
      </template>
    </AnalysisSection>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import AnalysisMixin from '@/components/Export/Analysis/Mixin';
import Impact from '@/components/Analysis/Environmental/Impact';

export default {
  name: 'ExportEnvironmental',

  components: {
    Impact,
  },

  mixins: [AnalysisMixin],

  computed: {
    ...mapGetters(['currentExportLayout']),

    environmentalMode() {
      switch (this.currentExportLayout?.environmental_mode) {
        case 0:
          return this.$t('sections.byYear');
        case 1:
          return this.$t('sections.byJourney');
        case 2:
          return this.$t('sections.byYearWeighted');
        default:
          return this.$t('sections.byYear');
      }
    },

    yearly() {
      return [0, 2].includes(this.currentExportLayout?.environmental_mode);
    },

    weighted() {
      return [2].includes(this.currentExportLayout?.environmental_mode);
    },
  },
};
</script>
